import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom';

function About() {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const sectionId = location.state.scrollTo;
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);
  return (
   <>
   
<div className="container-xxl py-5" id='about'>
  <div className="container">
    <div className="row g-5">
      <div
        className="col-lg-6 wow fadeInUp"
        data-wow-delay="0.1s"
        style={{ minHeight: 400 }}
      >
        <div className="position-relative h-100">
          <div
            id="aboutCarousel"
            className="carousel slide h-100"
            data-bs-ride="carousel"
          >
            <div className="carousel-inner h-100">
              <div className="carousel-item active h-100">
                <img
                  className="img-fluid position-absolute w-100 h-100"
                  src="https://cdn.pixabay.com/photo/2024/02/22/02/45/computer-8589003_640.png"
                  alt="About Image 1"
                
                />
              </div>
              <div className="carousel-item h-100">
                <img
                  className="img-fluid position-absolute w-100 h-100"
                 src="https://cdn.pixabay.com/photo/2024/06/14/12/15/developer-8829709_640.jpg"
                  alt="About Image 2"
             
                />
              </div>
              <div className="carousel-item h-100">
                <img
                  className="img-fluid position-absolute w-100 h-100"
                 src="https://cdn.pixabay.com/photo/2024/08/03/13/05/ai-generated-8942076_640.png"
                  alt="About Image 3"
             
                />
              </div>
            </div>

            <button
              className="carousel-control-prev"
              type="button"
              data-bs-target="#aboutCarousel"
              data-bs-slide="prev"
            >
              <span className="carousel-control-prev-icon" aria-hidden="true"></span>
              <span className="visually-hidden">Previous</span>
            </button>
            <button
              className="carousel-control-next"
              type="button"
              data-bs-target="#aboutCarousel"
              data-bs-slide="next"
            >
              <span className="carousel-control-next-icon" aria-hidden="true"></span>
              <span className="visually-hidden">Next</span>
            </button>
          </div>
        </div>
      </div>
      <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
     
        <h1 className="mb-4 Heading">Welcome to CoderMonk</h1>
        <p className="mb-4">
      The cool kid on the coding block.🚀 We’re not just any training institute. We’re your coding zen master, where you don’t just learn to code, you learn to innovate, create, and take on the tech world like a pro! Born from DigitalMonk, the big tech boss in town, we believe in teaching what’s real, relevant, and today’s tech. From Full Stack to Embedded Systems, we don’t just fill your head with theory—we equip you with the skills you’ll actually use in the field.🔧💻
        </p>
        <p className="mb-4">
        And guess what? No contracts, no boring lectures, and we don’t do “cookie-cutter” education. It’s all about you—learning at your own pace, solving real problems, and getting you job-ready. Think of us as your coding family—you learn, grow, and we’ve got your back! Let’s make coding fun again!🔥
        </p>
      </div>
    </div>
  </div>
</div>
   </>
  )
}

export default About